import * as React from "react";
import { Switch } from "react-router-dom";
import { PrivateRoute } from "../../Core/PrivateRoute";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { CreateSiteScreen } from "./CreateSiteScreen";
import { EditSiteScreen } from "./EditSiteScreen";
import { SitesList } from "./SitesList";
import { ViewSiteScreen } from "./ViewSiteScreen";

export const SiteScreen = () => {
    return (
        <Switch>
            <PrivateRoute exact path="/Sites" permissions={[PermissionEnum.ViewSites, PermissionEnum.CreateSite, PermissionEnum.EditSite]}>
                <SitesList />
            </PrivateRoute>
            <PrivateRoute exact path="/Sites/Create" permissions={[PermissionEnum.CreateSite]}>
                <CreateSiteScreen />
            </PrivateRoute>
            <PrivateRoute path="/Sites/Edit/:id" permissions={[PermissionEnum.EditSite]}>
                <EditSiteScreen />
            </PrivateRoute>
            <PrivateRoute path="/Sites/View/:id" permissions={[PermissionEnum.ViewSites]}>
                <ViewSiteScreen />
            </PrivateRoute>
        </Switch>
    );
}
